import moment from 'moment';
import { toNumber } from 'lodash';
import { humanize } from '@utils';
import { getTextColor } from '@components/overview-dashboard/metrics-container/spi-widget/SPIMetricsText';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg = 'day') => {
  if (arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
};

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT),
  };
};

export const humanizeValue = (value) => {
  return humanize(value, '');
};

export const getSpiText = (value) => {
  return getTextColor(humanizeValue(toNumber(value)));
};
